import { render } from "./SalesReceipt.vue?vue&type=template&id=655b8bb1&scoped=true&ts=true"
import script from "./SalesReceipt.vue?vue&type=script&lang=ts"
export * from "./SalesReceipt.vue?vue&type=script&lang=ts"

import "./SalesReceipt.vue?vue&type=style&index=0&id=655b8bb1&scoped=true&lang=css"

import exportComponent from "/Users/abdulkarim/workspace/public_html/joypurhost/pos2/pos2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-655b8bb1"]])

export default __exports__